require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-pictela-premium-formats.json") })
        }
      }, "path---projects-pictela-premium-formats");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-pictela-premium-formats!./.cache/json/projects-pictela-premium-formats.json
// module id = 367
// module chunks = 231608221292675